import { arrayToObj } from '@/utils/utils'
import i18n from '@/locales'

export const COST_REPORT_PERIOD_TYPES = [
  { key: 'one_time', value: i18n.t('bill.period_type_one_time') },
  { key: 'day', value: i18n.t('bill.period_type_day') },
  { key: 'week', value: i18n.t('bill.period_type_week') },
  { key: 'month', value: i18n.t('bill.period_type_month') },
]

export const COST_REPORT_PERIOD_TYPE_MAP = arrayToObj(COST_REPORT_PERIOD_TYPES, 'key')

export const COST_REPORT_BILLING_TYPES = [
  { key: 'current_month', value: i18n.t('bill.subscription_billing_type_current_month') },
  { key: 'last_month', value: i18n.t('bill.subscription_billing_type_last_month') },
  { key: 'custom', value: i18n.t('bill.subscription_billing_type_custom') },
]

export const COST_REPORT_BILLING_TYPE_MAP = arrayToObj(COST_REPORT_BILLING_TYPES, 'key')

export const WEEK_DAYS = [
  { key: 1, value: i18n.t('bill.subscription_week_days_1') },
  { key: 2, value: i18n.t('bill.subscription_week_days_2') },
  { key: 3, value: i18n.t('bill.subscription_week_days_3') },
  { key: 4, value: i18n.t('bill.subscription_week_days_4') },
  { key: 5, value: i18n.t('bill.subscription_week_days_5') },
  { key: 6, value: i18n.t('bill.subscription_week_days_6') },
  { key: 7, value: i18n.t('bill.subscription_week_days_7') },
]

export const WEEK_DAY_MAP = arrayToObj(WEEK_DAYS, 'key')
